<template>
  <component :is="stateMap" class="state-map"></component>
</template>

<script>
    import { defineAsyncComponent } from "vue";

    export default {
        name: "state-map",
        props: {
            currentState: String,
        },
        computed: {
            stateMap(){
              const lowercaseState = this.currentState.toLowerCase();
              return defineAsyncComponent(() => import(`../../assets/state_svgs/${lowercaseState}.svg`));
            },
        },
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";

    .state-map {
      max-height: 500px;
      fill: $primary;
      stroke:  $primary;
    }
</style>